import { render, staticRenderFns } from "./EditSaleRate.vue?vue&type=template&id=2dd21153&scoped=true"
import script from "./EditSaleRate.vue?vue&type=script&lang=js"
export * from "./EditSaleRate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd21153",
  null
  
)

export default component.exports